/* eslint-disable */
import PropTypes from "prop-types";
import { useEffect, useMemo, useRef, useState } from "react";
import "./styles.scss";

export default function MessageCell({ payload }) {
  const containerRef = useRef(null);
  const textRef = useRef(null);
  const [overflowing, setOverflowing] = useState(false);

  const msgText = useMemo(() => {
    if (typeof payload === "object" && payload !== null) return JSON.stringify(payload);
    return String(payload ?? "");
  }, [payload]);

  // Detect real visual overflow: if the text's scrollWidth exceeds its clientWidth
  const checkOverflow = () => {
    if (!textRef.current) return;
    setOverflowing(textRef.current.scrollWidth > textRef.current.clientWidth);
  };

  useEffect(() => {
    checkOverflow();
    const ro = new ResizeObserver(() => checkOverflow());
    if (containerRef.current) ro.observe(containerRef.current);
    return () => ro.disconnect();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [msgText]);

  return (
    <div ref={containerRef} className="ocpp-msg-wrap">
      <span ref={textRef} className="ocpp-msg-ellipsis" title={msgText}>
        {msgText}
      </span>
    </div>
  );
}

MessageCell.propTypes = {
  payload: PropTypes.any,
};
